import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  eventStatusEnum: [],
  eventStatus: [],
  eventTypes: [],
  currentEvent: {},
  eventPermissions: [],
  inscriptionStatusEnum: [],
  participators: [],
  variables: [],
  invitationStatus: [],
  templateKey: '' ,
  currentInvitation : null,
  validatedParticipators: []
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
